
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";

interface BillingToggleProps {
  id?: string;
  isAnnual: boolean;
  onToggle: (isAnnual: boolean) => void;
}

const BillingToggle = ({ id = "billing-toggle", isAnnual, onToggle }: BillingToggleProps) => {
  return (
    <div id={id} className="flex items-center justify-center space-x-4 mb-2.5">
      <Label 
        id={`${id}-monthly-label`}
        htmlFor={`${id}-switch`} 
        className={`text-sm font-medium transition-colors ${!isAnnual ? 'text-foreground' : 'text-muted-foreground'}`}
      >
        Monthly
      </Label>
      <Switch
        id={`${id}-switch`}
        checked={isAnnual}
        onCheckedChange={onToggle}
        className="data-[state=checked]:bg-amber-600"
      />
      <Label 
        id={`${id}-annual-label`}
        htmlFor={`${id}-switch`} 
        className={`text-sm font-medium transition-colors ${isAnnual ? 'text-foreground' : 'text-muted-foreground'}`}
      >
        Annual
        <span className="ml-1 text-xs text-amber-600 font-semibold">Save up to 20%</span>
      </Label>
    </div>
  );
};

export default BillingToggle;
